const gridLogin = {
 text1: 'Hola ',
 text2: ', el siguiente acceso será agregado a su cuenta:'
};

export default gridLogin;
